import React from 'react'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'

import { Text } from '@mxenabled/mxui'
import { ChevronRight } from '@mxenabled/mx-icons'

export enum Action {
  Connections = 'connections',
  CreditScore = 'credit_score',
  DateOfBirth = 'date_of_birth',
  MonthlyIncome = 'monthly_income',
}

interface ProfileListItem {
  icon: React.ReactNode
  isComplete: boolean
  key: Action
  primaryText: string
  secondaryText: string
}

interface ProfileListProps {
  list: ProfileListItem[]
  onClickItem: (action: Action) => void
}

const ProfileList = ({ list, onClickItem }: ProfileListProps) => (
  <Box sx={{ bgcolor: 'background.paper' }}>
    <List
      sx={{
        '& .MuiListItemSecondaryAction-root': {
          color: 'text.primary',
          pr: 24,
        },
      }}
    >
      {list.map((item, i) => (
        <React.Fragment key={item.key}>
          <ListItem secondaryAction={<ChevronRight />}>
            <ListItemButton onClick={() => onClickItem(item.key)}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: 'primary.main',
                    ...(!item.isComplete && {
                      bgcolor: 'transparent',
                      borderColor: 'action.active',
                      borderStyle: 'solid',
                      borderWidth: 1,
                      color: 'action.active',
                    }),
                  }}
                >
                  {item.icon}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Text sx={{ color: 'text.secondary' }} variant="caption">
                    {item.primaryText}
                  </Text>
                }
                secondary={
                  <Text sx={{ color: 'text.primary', fontWeight: 600 }} variant="body1">
                    {item.secondaryText}
                  </Text>
                }
              />
            </ListItemButton>
          </ListItem>
          <Divider sx={{ color: 'divider', ml: i === list.length - 1 ? 0 : 68 }} />
        </React.Fragment>
      ))}
    </List>
  </Box>
)

export default ProfileList
